{
  "schemaVersion": 1,
  "coordinateConvention": "normalized geometric bounds 0..1 in both axes, excluding guide stroke; tip at y=0, cuticle toward y=1",
  "reviewStatus": "technical fixture only",
  "shapes": [
    {
      "id": "round",
      "version": "0.1.0",
      "normalizedPathD": "M 0 0.45 C 0 0.12 0.28 0 0.5 0 C 0.72 0 1 0.12 1 0.45 L 1 0.83 Q 1 1 0.5 1 Q 0 1 0 0.83 Z"
    },
    {
      "id": "oval",
      "version": "0.1.0",
      "normalizedPathD": "M 0 0.50 C 0 0.17 0.26 0 0.5 0 C 0.74 0 1 0.17 1 0.50 L 1 0.82 Q 1 1 0.5 1 Q 0 1 0 0.82 Z"
    },
    {
      "id": "almond",
      "version": "0.1.0",
      "normalizedPathD": "M 0.5 0 C 0.72 0.08 1 0.33 1 0.66 L 1 0.82 Q 1 1 0.5 1 Q 0 1 0 0.82 L 0 0.66 C 0 0.33 0.28 0.08 0.5 0 Z"
    },
    {
      "id": "square",
      "version": "0.1.0",
      "normalizedPathD": "M 0 0 L 1 0 L 1 0.82 Q 1 1 0.5 1 Q 0 1 0 0.82 Z"
    },
    {
      "id": "squoval",
      "version": "0.1.0",
      "normalizedPathD": "M 0.20 0 L 0.80 0 Q 1 0 1 0.13 L 1 0.82 Q 1 1 0.5 1 Q 0 1 0 0.82 L 0 0.13 Q 0 0 0.20 0 Z"
    },
    {
      "id": "coffin",
      "version": "0.1.0",
      "normalizedPathD": "M 0.30 0 L 0.70 0 L 1 0.59 L 1 0.82 Q 1 1 0.5 1 Q 0 1 0 0.82 L 0 0.59 Z"
    },
    {
      "id": "stiletto",
      "version": "0.1.0",
      "normalizedPathD": "M 0.5 0 C 0.64 0.18 1 0.44 1 0.70 L 1 0.82 Q 1 1 0.5 1 Q 0 1 0 0.82 L 0 0.70 C 0 0.44 0.36 0.18 0.5 0 Z"
    }
  ]
}
